import DatetimeHelper from "@/helper/DatetimeHelper";

export function SearchHistoryModel(dict) {
    this.partitionKey = dict.PartitionKey || '';
    this.rowKey = dict.RowKey || '';
    this.keyword = dict.Keyword || '';
    this.timestamp = dict.Timestamp || '';
    this.dateTime = dict.Timestamp ? DatetimeHelper.getDateFormatShortMonthWithTimeNotUtc(dict.Timestamp) : '';
    this.eTag = dict.ETag || '';
    
    this.userId = dict.userId || '';
    this.info = dict.Info || '';
    this.detail = dict.Detail || '';
    this.points = dict.Points || '';
    this.type = dict.Type || '';
    this.caller = dict.Caller || '';
    this.pair = dict.Pair || '';
    this.message = dict.Message || '';
    this.campaignId = dict.CampaignId || '';
    this.campaignName = dict.CampaignName || '';
    this.createDate = dict.CreateDate || '';
    this.input = dict.Input || '';
    try{ 
        this.inputJson = dict.Input ? JSON.parse(dict.Input) : {};
    }catch(e){
        //
    }
    /*
    "RowKey": "SmCVD-MqwAwvIhzTeF7JAG-hNYmP13mKk|2026M09",
    "UserId": "TCW_1715605915748",
    "Info": null,
    "Detail": "",
    "Points": -199,
    "Type": "transfer",
    "Caller": "TCW_1715605915748",
    "Pair": "TCW_1718374254746",
    "Timestamp": 1720496042,
    "Message": "",
    "CampaignId": null,
    "CampaignName": null,
    "CreateDate": null,
    "Input": "{\"Source\":{\"UserId\":\"TCW_1715605915748\",\"ContactNumber\":\"0831942994\"},\"Destination\":{\"UserId\":\"TCW_1718374254746\",\"ContactNumber\":\"0868994948\"}}"
    */
}
